<template>
  <div>
    <vs-row>
      <vs-col vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-w="12">
        <vs-table
          search
          pagination
          :data="players"
          max-items="25"
          description
          :description-items="[25, 50, 100]"
          description-title="Players"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <vs-row>
              <vs-col vs-w="3" vs-xs="12" vs-sm="12" style="margin: 5px 0;">
                <h3>Roster</h3>
              </vs-col>
            </vs-row>
          </template>
          <template slot="thead">
            <vs-th sort-key="firstname">Firstname</vs-th>
            <vs-th sort-key="lastname">Lastname</vs-th>
            <vs-th v-if="showEmail" sort-key="email">Email</vs-th>
            <vs-th sort-key="jersey">Jersey</vs-th>
            <vs-th></vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="d" v-for="(d, index) in data">
              <vs-td :data="d.firstname">{{ d.firstname }}</vs-td>
              <vs-td :data="d.lastname">{{ d.lastname }}</vs-td>
              <vs-td v-if="showEmail" :data="d.email">{{ d.email }}</vs-td>
              <vs-td :data="d.jersey">{{ d.jersey }}</vs-td>
              <vs-td v-if="showEmail">
                <vs-button
                  style="float:right;margin: 0 2px"
                  radius
                  color="primary"
                  type="border"
                  icon="photo"
                  @click="openPlayerPhotoUpload(d)"
                />
                <vs-button
                  style="float:right;margin: 0 2px"
                  radius
                  color="primary"
                  type="border"
                  icon="edit"
                  @click="$emit('editPlayer', d)"
                />
              </vs-td>
              <vs-td v-if="!showEmail">
                <vs-button
                  style="float:right;margin: 0 2px"
                  radius
                  color="primary"
                  type="gradient"
                  icon="info"
                  @click="
                    $router.push({ name: 'player', params: { id: d.id } })
                  "
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-col>
    </vs-row>
  </div>
</template>
<script>
import UserRoles from "@/mixins/UserRoles";
import { mapActions } from "vuex";
import { bus } from "@/main";
export default {
  name: "roster-listing",
  props: {
    team: {
      required: true
    },
    showEmail: {
      default: false
    }
  },
  created() {
    bus.$on("load-players", this.loadTeamRoster);
  },
  mounted() {
    if (this.team && this.user && this.showEmail) this.loadRoster();
    else if (this.team) this.loadTeamRoster();
  },
  mixins: [UserRoles],
  data: () => ({
    players: []
  }),
  methods: {
    ...mapActions({
      getTeamRoster: "team/getTeamRoster",
      getRoster: "team/getRoster",
      updatePlayerPhoto: "team/updatePlayerPhoto"
    }),
    async loadTeamRoster() {
      this.$vs.loading();
      const { json } = await this.getTeamRoster({ id: this.team.season[0].id });
      this.players = json.reverse();
      this.$vs.loading.close();
    },
    async loadRoster() {
      this.$vs.loading();
      const { json } = await this.getRoster({ id: this.team.season[0].id });
      this.players = json.reverse();
      this.$vs.loading.close();
    },
    openPlayerPhotoUpload(player) {
      window.cloudinary.openUploadWidget(
        {
          cloud_name: "ballstar",
          upload_preset: "player_photo"
        },
        async (error, result) => {
          if (!error && result && result.event === "success") {
            console.log("result", result.info);

            await this.updatePlayerPhoto({
              data: {
                id: player.id,
                photo: result.info,
                teamId: this.team.season[0].id
              }
            });
          }
        }
      );
    }
  }
};
</script>
